/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function NuevoAccesoMovilidad({ onClose: e, onCreado: t }) {
  let n = Go(),
    [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(!1);
  async function l(e) {
    if ((e.preventDefault(), !s)) {
      (c(!0), o(``));
      try {
        let e = await api(`/transporte/enlaces`, {
          method: `POST`,
          body: JSON.stringify({
            nombre: r.trim(),
          }),
        });
        (n.ok(`Acceso de ${e.nombre} listo — copialo y pasáselo`), t(e));
      } catch (e) {
        o(e.message);
      } finally {
        c(!1);
      }
    }
  }
  return (
    <Modal
      titulo={`Nuevo acceso`}
      onClose={e}
      children={
        <form
          onSubmit={l}
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `¿De quién va a ser?`,
                <input
                  autoFocus={!0}
                  value={r}
                  onChange={(e) => i(e.target.value)}
                  placeholder={`Transporte — Ica`}
                  className={Lo}
                />,
              ]}
            />,
            <p
              className={`text-xs text-(--text)`}
              children={`El nombre es para saber cuál dar de baja si hace falta.`}
            />,
            a && <p className={`text-sm text-(--error)`} children={a} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={e}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={s || !r.trim()}
                  className={Ro}
                  children={s ? `Creando…` : `Crear`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
